export default __webpack_public_path__ + "static/media/bca.3b2f26e5.svg";